import { createContext } from "react";

const CompanyContext = createContext({
  company : {},
  setCompany : () => {}
});

export { CompanyContext };